module.exports = __webpack_public_path__ + "img/drawtex.d1f7e0ce.jpg";